import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/core/common-services/user.services';

export interface HoldingsLanguageDialogData {
  type: 'excel' | 'pdf';
  initialLanguage?: 'ar' | 'en';
}

export interface HoldingsLanguageDialogResult {
  language: 'ar' | 'en';
}

@Component({
  selector: 'app-holdings-language-dialog',
  templateUrl: './holdings-language-dialog.component.html',
  styleUrls: ['./holdings-language-dialog.component.css']
})
export class HoldingsLanguageDialogComponent implements OnInit {
  selectedLanguage: 'ar' | 'en' = 'en';

  constructor(
    public dialogRef: MatDialogRef<HoldingsLanguageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HoldingsLanguageDialogData,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    if (this.data?.initialLanguage) {
      this.selectedLanguage = this.data.initialLanguage;
    } else {
      this.selectedLanguage = this.detectCurrentUiLanguage();
    }
  }

  detectCurrentUiLanguage(): 'ar' | 'en' {
    const saved = (
      localStorage.getItem('language') ||
      this.userService?.getCurrentSystemLanguage() ||
      (typeof document !== 'undefined' ? document.documentElement.lang : '') ||
      ''
    ).toLowerCase();

    if (saved.startsWith('ar') || (typeof document !== 'undefined' && document.documentElement.dir === 'rtl')) {
      return 'ar';
    }
    return 'en';
  }

  download(): void {
    if (!this.selectedLanguage) {
      return;
    }
    this.dialogRef.close({ language: this.selectedLanguage });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
